import styled from 'styled-components';

export const TransitionInOutControlStyled = styled.div`
    position: relative;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
